<mat-card class="information-program-card">
  <mat-card-header>
    <div mat-card-avatar class="modbus-header-image">
      <mat-icon aria-hidden="false" aria-label="home icon">api</mat-icon>
    </div>
    <mat-card-title>Program Running</mat-card-title>

  </mat-card-header>

  <mat-card-content>

    <mat-list>

      <mat-list-item>
        <mat-icon mat-list-icon>account_box</mat-icon>
        <div mat-line> Config: {{ information.client_started }} </div>
        <div mat-line> Option given in start.</div>
      </mat-list-item>

      <mat-list-item>
        <mat-icon mat-list-icon>account_box</mat-icon>
        <div mat-line> Client: {{ information.running_kop }}<span class="material-icons">toggle_on</span></div>
        <div mat-line> Active one</div>

      </mat-list-item>
      <mat-list-item>
        <mat-icon mat-list-icon>folder</mat-icon>

        <div mat-line> Version: {{ information.running_program }}  <span class="material-icons">toggle_on</span></div>
      </mat-list-item>
      <mat-list-item>
        <mat-icon mat-list-icon>more_time</mat-icon>
        <div mat-line> Climate uptime: {{ information.climate_running_time }}</div>
      </mat-list-item>


      <mat-list-item>
        <mat-icon mat-list-icon>face</mat-icon>
        <div mat-line> Kop in board: {{ information.board_kop }}</div>
      </mat-list-item>

      <mat-list-item>
        <mat-icon mat-list-icon>fingerprint</mat-icon>
        <div mat-line> Board ID: {{ information.board_id }}</div>
      </mat-list-item>

    </mat-list>
  </mat-card-content>
</mat-card>


